import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const EmailVerificationResult = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const success = params.get('success') === 'true';
  const message = params.get('message');
  const error = params.get('error');

  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(intervalId);
          window.location.href = "https://developer-ai.com";
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>{success ? "Email Verified" : "Verification Failed"}</h2>
        <p>
          {success
            ? (message || "Your email has been successfully verified.")
            : (error || "There was an error verifying your email.")}
        </p>
        <p style={{ marginTop: '20px' }}>
          Redirecting to developer-ai.com in {countdown} seconds...
        </p>
        <p>
          If you're not redirected automatically,{' '}
          <a href="https://developer-ai.com">click here</a>.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(600px, 90vw)',
    height: 'min(600px, 90vw)',
    padding: '0.5rem',
    boxSizing: 'border-box',
    borderRadius: '8px',
    backgroundColor: 'lightblue',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    width: '90%',
    maxWidth: '400px',
  },
};

export default EmailVerificationResult;
